const SubSection = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--gap)",
        paddingBottom: "var(--gap)",
        alignItems: "flex-start",
      }}
    >
      {children}
    </div>
  );
};

export default SubSection;
